import { insertBefore } from '../html';
import { getCategory } from './api';
import { CommentsForm, CommentsFormNotice } from './form';
import { CommentsListing } from './listing';
import { CommentsOptions, CommentsOptionsRetryAction, CommentsOptionsLockAction } from './options';

export const CommentsSection = function(args) {
    let { category: catName } = args ?? {};

    const options = new CommentsOptions;
    const listing = new CommentsListing({ root: true });
    const element = <div class="comments">
        {options}
        {listing}
    </div>;

    let form;
    let retryAct;

    const clearForm = () => {
        if(form) {
            element.removeChild(form.element);
            form = undefined;
        }
    };
    const setForm = elem => {
        clearForm();
        form = elem;
        insertBefore(element.firstChild, form.element);
    };
    const initForm = (userInfo, catInfo) => {
        if(!userInfo)
            setForm(new CommentsFormNotice({ body: 'You must be logged in to post comments.' }));
        else if(!userInfo.can_create)
            setForm(new CommentsFormNotice({ body: 'You are not allowed to comment.' }));
        else if(catInfo.locked)
            setForm(new CommentsFormNotice({ body: 'This comment section is closed.' }));
        else
            setForm(new CommentsForm({ userInfo, catInfo, listing }));
    };

    const pub = {
        get element() { return element; },

        async reload() {
            clearForm();
            listing.reset();

            try {
                const { user, category, posts } = await getCategory(catName);

                retryAct = undefined;
                options.reset();

                initForm(user, category);

                if(user?.can_lock)
                    options.appendAction(new CommentsOptionsLockAction(
                        category,
                        () => {
                            initForm(user, category);
                            listing.updateLocked();
                        }
                    ));

                listing.addPosts(category, user, posts);
            } catch(ex) {
                console.error(ex);
                listing.removeLoading();

                form = new CommentsFormNotice({ body: 'Failed to load comments.' });
                insertBefore(element.firstChild, form.element);

                if(!retryAct)
                    options.appendAction(retryAct = new CommentsOptionsRetryAction(pub));
            }
        },
    };

    pub.reload();

    return pub;
};
